<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card title="Filtro de Pesquisa">
          <v-form ref="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field
                    autofocus
                    v-uppercase
                    v-model="search.nome"
                    label="Nome/CPF"
                    name="Nome"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col class="mt-3" cols="12" md="3" sm="6">
                  <v-btn @click="buscar()" color="primary">
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                  <v-btn @click="limpar()" class="ml-1" color="primary">
                    <v-icon left>mdi-autorenew</v-icon>Limpar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
        <material-card title="Usuários" class="mt-3">
          <v-row justify="end">
            <v-col cols="12" md="12" class="text-right">
              <v-btn @click="novoUsuario()" small color="primary">
                <v-icon left>mdi-plus</v-icon>Novo
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :fixed-header="true"
            fix-header
            :headers="headers"
            :items="usuarios"
            :single-select="false"
            :footer-props="{'items-per-page-options': [10, 50, 100]}"
            :items-per-page="10"
            :options.sync="options"
            :server-items-length="paginacao.total"
            class="elevation-1 mt-3"
          >
            <template v-slot:item.cpf="{ item }">{{item.cpf | formata("documento")}}</template>
            <template v-slot:item.celular="{ item }">{{item.celular | formata("telefone") }}</template>
            <template v-slot:item.acao="{ item }">
              <v-menu bottom left v-if="$vuetify.breakpoint.sm && $user.id !== item.id">
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on" color="accent">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editItem(item)">
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteItem(item)">
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip v-if="!$vuetify.breakpoint.sm && $user.id !== item.id" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
                </template>
                <span>Alterar dados</span>
              </v-tooltip>
              <v-tooltip v-if="!$vuetify.breakpoint.sm" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="lancarBoletos(item)">mdi-ballot</v-icon>
                </template>
                <span>Lançar Boletos</span>
              </v-tooltip>
              <v-tooltip v-if="!$vuetify.breakpoint.sm && $user.id !== item.id" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <modal-cadastro :open-modal.sync="abrirModalNovaPessoa" :current="currentUsuario" :callback="callbackUsuarioCadastrado"></modal-cadastro>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import ModalCadastro from "./ModalCadastro";

export default {
   components: {
    ModalCadastro,    
  },
  data() {
    return {
      usuarios: [],
      options: {},
      abrirModalNovaPessoa: false,
      currentUsuario: false,
      search: {
        nome: "",
      },
      paginacao: {
        total: 0,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.buscarClientes();
      },
    },
  },
  methods: {
    ...mapActions("usuario", ["salvar", "atualizar", "remover", "obterTodos"]),
    novoUsuario() {
        this.currentUsuario = false;
        this.abrirModalNovaPessoa = true;
    },
    editItem(item) {
        this.currentUsuario = item;
        this.abrirModalNovaPessoa = true;
    },
    buscarClientes() {
      this.obterTodos({
        ps: this.options.itemsPerPage,
        page: this.options.page,
        q: this.search.nome,
      }).then((data) => {
        this.paginacao.total = data.total;
        this.usuarios = data.items;
      });
    },
    lancarBoletos(item) {
      this.$router.push({
        name: "BoletoCpf",
        params: { cpf: item.cpf },
      });
    },
    callbackUsuarioCadastrado(data) {
        if (this.currentUsuario === false)
            this.usuarios.push(data);
        else 
            this.buscarClientes();        
    },
    limpar() {
      this.search.nome = "";
      this.options.itemsPerPage = 10;
      this.options.page = 1;
      this.buscarClientes();
    },
    buscar() {
      this.buscarClientes();
    },
  },
  computed: {
    headers() {
      let headersArray = [];

      headersArray.push({
        text: "Nome",
        align: "left",
        sortable: false,
        value: "nome",
        class: "disabled",
      });

      headersArray.push({
        text: "Email",
        align: "left",
        sortable: false,
        value: "email",
        class: "disabled",
      });

      headersArray.push({
        text: "CPF",
        align: "left",
        sortable: false,
        value: "cpf",
        class: "disabled",
      });

      headersArray.push({
        text: "Celular",
        value: "celular",
        sortable: false,
        align: "center",
      });

      headersArray.push({
        text: "Ação",
        value: "acao",
        sortable: false,
        align: "center",
      });

      return headersArray;
    },
  },
};
</script>